import React from 'react';
import { BundleIssue } from '../../api/bundle';
import { FieldIssue } from './WizardShell';

// 向导里「随套件新建」字典项的公共展示件 (2026-09-29, 设备向导 / 材料向导共用):
// 就地新建的模式值、字段组不再单独提审, 而是记进套件 newDicts 随整包一个工单落库.

/** PendingTag 「随套件新建」标记: 这一项还不在字典里, 随本套件工单一起落库. */
export function PendingTag() {
    return (
        <span
            className="tag bg-amber-50 text-amber-700 font-normal text-[11px]"
            title="还不在字典里: 随本套件一起提交审批, 通过后与主体同一事务创建"
        >
            随套件新建
        </span>
    );
}

/** PrefixIssues 按路径前缀汇总预检问题 (newDicts 的报错落在 newDicts.xxx[i].yyy 这类下标路径上). */
export function PrefixIssues({
    issueByPath,
    prefixes,
}: {
    issueByPath: Record<string, BundleIssue>;
    prefixes: string[];
}) {
    const hits = Object.entries(issueByPath).filter(
        ([path, i]) =>
            i.severity !== 'info' && prefixes.some((p) => path.startsWith(p)),
    );
    if (!hits.length) return null;
    return (
        <>
            {hits.map(([path, i]) => (
                <FieldIssue key={path} issue={i} />
            ))}
        </>
    );
}
